// extracted by mini-css-extract-plugin
module.exports = {"svg":"CircularProgress_svg_SgDL-"};